import React from 'react';
import { PlayerButton } from './PlayerButton';

interface SkipBackButtonProps {
  mediaElementId: string;
  onClick: () => void;
}

export const SkipBackButton = React.memo(function SkipBackButton({ mediaElementId, onClick }: SkipBackButtonProps) {
  return (
    <PlayerButton
      className="kollab-player-skip-back-btn"
      tooltip="Back 5 seconds"
      aria-controls={mediaElementId}
      onClick={onClick}
    />
  );
});
